import styled from 'styled-components';

export const Container = styled.section.attrs({
  className: 'container',
})`
  position: relative;
`;
